var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatepickers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.14202 0.0296631C4.53495 0.0296631 4.85348 0.348194 4.85348 0.741121V1.45258H9.83369V0.741121C9.83369 0.348194 10.1522 0.0296631 10.5451 0.0296631C10.9381 0.0296631 11.2566 0.348194 11.2566 0.741121V1.47014C13.0542 1.64862 14.4582 3.16529 14.4582 5.00987V11.413C14.4582 13.3776 12.8655 14.9703 10.9009 14.9703H3.7863C1.82166 14.9703 0.229004 13.3776 0.229004 11.413V5.00987C0.229004 3.16529 1.63295 1.64862 3.43057 1.47014V0.741121C3.43057 0.348194 3.7491 0.0296631 4.14202 0.0296631ZM1.77337 4.29841H12.9138C12.6208 3.46943 11.8302 2.8755 10.9009 2.8755H3.7863C2.85698 2.8755 2.06638 3.46943 1.77337 4.29841ZM13.0353 5.72133H1.65192V11.413C1.65192 12.5918 2.60751 13.5474 3.7863 13.5474H10.9009C12.0797 13.5474 13.0353 12.5918 13.0353 11.413V5.72133ZM3.07484 7.8557C3.07484 7.46278 3.39337 7.14425 3.7863 7.14425H10.9009C11.2938 7.14425 11.6123 7.46278 11.6123 7.8557C11.6123 8.24863 11.2938 8.56716 10.9009 8.56716H3.7863C3.39337 8.56716 3.07484 8.24863 3.07484 7.8557Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatepickers);
export default __webpack_public_path__ + "static/media/datepickers.75ec7099452a6cd5cdfab76507275d5f.svg";
export { ForwardRef as ReactComponent };